<template>
    <!--
        Notification component.
        Displays single notification in Notification queue.
    -->
    <div class="notify">

        <template v-for="(note, index) in queue">
            <transition name="notify">
            <div class="notification" :class="'notification--' + note.type" v-if="note.show">

                <div v-show="note.icon.length">
                    <icon :name="note.icon" />
                </div>

                <span v-if="note.headline.length">{{ note.headline }}</span>
                <p v-if="note.description.length" v-html="note.description"></p>
            </div>
            </transition>
        </template>

    </div>
</template>

<script>
import events from '../../events/events';

export default
{
    name: 'Notification',

    data()
    {
        return {
            queue: [],
            minWait: 3500,
            open: 0,
        }
    },

    created()
    {
        /**
         * @param {String} headline
         * @param {String} description
         * @param {String} icon
         * @param {String} type
         */
        events.$on('notification.open', (headline, description, icon, type) =>
        {
            this.queue.push({
                headline: (headline && typeof headline == 'string')? headline : '',
                description: (description && typeof description == 'string')? description : '',
                icon: icon || '',
                type: type || 'default',
                show: false,
            });

            let index = this.queue.length - 1;

            // give user 50 miliseconds per letter to read
            this.queue[index].duration = Math.max((this.queue[index].headline.length + this.queue[index].description.length) * 50, this.minWait);

            this.queue[index].show = true;
            this.open++;

            setTimeout(() =>
            {
                this.queue[index].show = false;
                this.open--;
            },
            this.queue[index].duration);
        });
    },

    watch:
    {
        open(val)
        {
            // this will reset the queue
            if (val == 0) this.queue = [];
        }
    },
}
</script>



// WEBPACK FOOTER //
// Notification.vue?6166aa56